import { createSlice } from '@reduxjs/toolkit'

import {
	initialStateTemplate,
	reducers,
} from '.reducers/libraries/library.template'

const initialState = {
	...initialStateTemplate,
	data: [],
	loaded: false,
	fetching: false,
	filters: [],
	favorites: 0,
	allFavorites: 0,
	currentPage: 1,
	totalOfPages: 0,
	totalResults: 0,
	uploading: false,
	uploaded: false,
	creating: false,
	created: false,
	actors: [],
	locations: [],
	deliveryNumbers: [],
}

const selects = createSlice({
	name: 'selects',
	initialState,
	reducers: {
		...reducers,
		fetched(state, { payload }) {
			if (Array.isArray(payload.data)) {
				state.data = payload.data
			}

			state.loaded = true
			state.fetching = false
			state.totalOfPages = Number(payload.totalOfPages) || 0
			state.totalResults = payload.totalResults
		},

		filters(state, { payload }) {
			state.filters = payload
		},

		favorites(state, { payload: favorites }) {
			state.favorites = favorites
		},

		setSelectFavorites(state, { payload }) {
			const targetSelect = state.data.find((s) => s.id === payload.id)
			targetSelect.favorites = payload.favorites
		},

		allFavorites(state, { payload: favorites }) {
			state.allFavorites = favorites
		},

		fetching(state, { payload }) {
			state.fetching = payload
		},

		loaded(state, { payload }) {
			state.loaded = payload
		},

		uploading() { },

		uploadingProgress(state, { payload }) {
			state.uploading[payload.file] = {
				...state.uploading[payload.file],
				progress: payload.progress,
			}
		},

		concludeUpload(state, { payload: fileName }) {
			state.uploading[fileName] = {
				...state.uploading[fileName],
				done: true,
			}
		},

		removeUpload(state, { payload: fileName }) {
			state.uploading[fileName] = undefined
		},

		uploadError(state, { payload }) {
			state.uploading[payload.file] = {
				...state.uploading[payload.file],
				error: payload.error,
			}
		},

		clear(state) {
			state.uploading = {}
			state.uploaded = false
		},

		locations(state, { payload }) {
			state.fetching_locations = false
			state.fetched_locations = true
			if (payload.data) {
				state.locations = payload.data
			}
		},

		uploaded(state) {
			state.uploading = false
			state.uploaded = true
		},

		setCompanyId(state, { payload: companyId }) {
			state.companyId = companyId
		},

		creating(state, { payload: creating }) {
			state.creating = creating
		},

		created(state) {
			state.creating = false
			state.created = true
		},

		setDeliveryNumbers(state, { payload }) {
			state.deliveryNumbers = payload
		}
	},
})

export const Creators = selects.actions
export const {
	setCompanyId,
	clearBkp,
	createAssetsBkp,
	restoreBkp,
	updateAsset,
	setDeliveryNumbers,
} = selects.actions

export default selects.reducer
